export default __webpack_public_path__ + "static/media/arrow-down.4e9ecc5c.svg";